import { motion } from 'framer-motion';
import { Shield, Activity, RotateCw } from 'lucide-react';

const missionPillars = [
  {
    id: 1,
    title: 'Protect',
    description: 'Keeping communities safer before emergencies happen.',
    icon: Shield,
  },
  {
    id: 2,
    title: 'Respond',
    description: 'Connecting citizens with responders within minutes.',
    icon: Activity,
  },
  {
    id: 3,
    title: 'Recover',
    description: 'Helping communities rebuild after crises.',
    icon: RotateCw,
  },
];

export default function NationalMissionSection() {
  return (
    <section className="py-24 bg-white text-[#0F172A]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="text-center mb-20">
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.1 }}
            transition={{ duration: 0.8 }}
            className="font-sans text-4xl md:text-5xl font-bold tracking-tight text-[#0F172A]"
          >
            National Mission
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {missionPillars.map((pillar, index) => {
            const Icon = pillar.icon;
            return (
              <motion.div
                key={pillar.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.1 }}
                transition={{ duration: 0.6, delay: index * 0.15 }}
                className="bg-[#F8FAFC] rounded-2xl p-10 flex flex-col items-center text-center border border-gray-100 hover:shadow-lg transition-shadow duration-300"
              >
                <div className="w-16 h-16 bg-[#16A34A]/10 rounded-full flex items-center justify-center mb-8">
                  <Icon className="w-8 h-8 text-[#16A34A]" />
                </div>
                <h3 className="font-sans text-2xl font-bold mb-4 text-[#0F172A]">
                  {pillar.title}
                </h3>
                <p className="text-[#0F172A]/70 text-lg leading-relaxed font-light">
                  {pillar.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
